<template lang="pug">
  .schedulingSettings
    .row.mt-4
        .col-12(v-for="(setting, index) in settings" v-if="isVisible(setting, index)").mt-4
            InputComponent(v-bind:inputObject="setting" :ref="setting.code").col-3
</template>

<script>
import {Validation} from '@/helpers'
import {InputComponent} from './../'
// import _ from 'lodash'

export default {
  name: 'SchedulingSettings',
  props:{
    settings: Array
  },
  components: {
      InputComponent,
  },
  data() {
    return {
        linkedObjects: {
            "EDA":[
                "every_day_at_minutes",
                "every_day_at_hours"
            ],
            "ENH":[
                "every_n_hours"
            ],
            "END":[
                "every_n_days",
                "every_n_days_at_time"
            ]
        }
    }
  },
  mounted() {
  },
  methods: {
    validate(){
      return Validation.validateFromRefs(this.$refs)
    },
    isVisible(setting, index){
        if(!this.currentSchedulingType && index > 1) return false;
        return (index < 2 || (index>=2 && this.linkedObjects[this.currentSchedulingType].includes(setting.code)));
    }
  },
  computed: {
      currentSchedulingType(){
          return this.settings[1].selectedValue;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less'); 
   .nav-tabs {
       a {
           color: #4a4a4a;
       }
       .active {
           color: @primary !important;
       }
   }
   .title {
       font-weight: bold;
   }
</style>
